import { ContainDefault } from './Container/ContainDefault';
import { FC } from 'react';
import { IAnswerModel } from '../../../state/stores/Question/AnswerModel';
import { IQuestionModel } from '../../../state/stores/Question/QuestionModel';
import { PresentDefault } from './Presentation/PresentDefault';
import { SnapshotOrInstance, SnapshotOut } from 'mobx-state-tree';
import { config } from './config';
import { isSpecialType } from './isSpecialType';
import { observer } from 'mobx-react';
import { useStores } from '../../../hooks/useStores';

export interface IKeyedQuestion extends SnapshotOut<IQuestionModel> {
  key: string;
}

const getAnswerSelectConfig = (question: SnapshotOut<IQuestionModel>) => {
  return question.key
    ? config[question.key as keyof typeof config]
    : undefined;
};

export interface AnswerSelectProps  {
  question: SnapshotOut<IQuestionModel>;
  onNext?: () => void;
}
const AnswerSelect: FC<AnswerSelectProps> = ({
  question,
  onNext,
}) => {

  const answerSelectConfig = getAnswerSelectConfig(question);
  const { treeNav } = useStores();
  const multi = question?.type === 'multiSelect';

  const onPressCommon = (answer: SnapshotOrInstance<IAnswerModel>) => {
    const specialTypeOfAnswer = isSpecialType(
      question.key,
      treeNav.choices.pending?.answers.map(a => a.key as string),
      treeNav.choices.pending?.answers.map(a => a.id)
    );
    if (multi) {
      // toggle answer in answers array
      treeNav.choices.updatePending({
        questionId: question._id,
        questionKey: question.key,
        answers: treeNav.choices.pending?.answers.some(a => a.id === answer._id)
          ? treeNav.choices.pending.answers.filter(a => a.id !== answer._id)
          : [...(treeNav.choices.pending?.answers || []), {
            id: answer._id,
            key: answer.key,
            meta: answer.meta,
          }],
        specialTypeOfAnswer,
      });
    } else {
      treeNav.choices.setPending({
        questionId: question._id,
        questionKey: question.key,
        answers: [{
          id: answer._id,
          key: answer.key,
          meta: answer.meta,
        }],
        specialTypeOfAnswer,
      });
      onNext?.();
    }
  };

  const Container = answerSelectConfig?.Container || ContainDefault;
  const Presentation = answerSelectConfig?.Presentation || PresentDefault;
  return (
    <Container
      question={question as IKeyedQuestion}
      onNext={onNext}
      onPress={onPressCommon}
    >
      {state => (
        <Presentation
          answers={state.answers}
          initSelected={state.initSelected}
          questionId={state.questionId}
          questionKey={state.questionKey}
          onPress={state.onPress}
          onNext={state.onNext}
          labels={state.labels}
          loading={state.loading}
        />
      )}
    </Container>
  );

};

export default observer(AnswerSelect);
